var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHashtag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#41505F",
  fillRule: "evenodd",
  d: "m20 7.77-.558 2.955h-2.79l-.559 2.955h2.79l-.371 2.955h-2.977l-.372 2.77h-2.977l.558-2.77H9.767l-.558 2.77H6.42l.372-2.77H4l.558-2.955h2.79l.559-2.955h-2.79l.371-2.955h2.977L8.837 5h2.977l-.558 2.77h2.977L14.79 5h2.79l-.372 2.77zm-6.326 2.955h-2.976l-.558 2.955h3.162z"
})));
export { SvgHashtag as ReactComponent };
export default __webpack_public_path__ + "static/media/hashtag.594f6f33.svg";